























import wrappers from '@/mixins/wrappers'
import { TranslateResult } from 'vue-i18n'
export default wrappers.extend({
  name: 'Goal-Feedback',
  props: {
    variant: {
      type: String,
      default: 'thank_you',
      validator: value => ['thank_you', 'we_understand'].includes(value)
    }
  },
  computed: {
    content (): Record<string, TranslateResult> {
      return this.variant === 'thank_you'
        ? {
          header: this.$t('Goal.Feedback.thank_you.header'),
          note: this.$t('Goal.Feedback.thank_you.note')
        }
        : {
          header: this.$t('Goal.Feedback.we_understand.header'),
          note: this.$t('Goal.Feedback.we_understand.note')
        }
    }
  },
  methods: {
    async dismiss () {
      await this.navigate({ name: 'Track' })
    }
  }
})
